import { render, staticRenderFns } from "./ProjectsOverview.vue?vue&type=template&id=a9fa6b24"
import script from "./ProjectsOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectsOverview.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsOverview.vue?vue&type=style&index=0&id=a9fa6b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports